export default function Video() {
  const player = new Plyr('#player', { controls: ['play', 'fullscreen'] })
  const modal = document.getElementById('modal-player-container')

  player.on('play', () => {
    modal.classList.add('modal--version')
    document.body.style.overflow = 'hidden'
  })

  document.addEventListener('click', (e) => {
    if (!modal.querySelector('.plyr--video').contains(e.target)) {
      modal.classList.remove('modal--version')
      document.body.style.overflow = ''
      player.pause()
    }
  })
}
